// extracted by mini-css-extract-plugin
export default {"scroll_button":"ScrollButton_scroll_button__i3kDQ","chevron":"ScrollButton_chevron__JkvQ9"};